/**
 * Service Cards - Click & Hover to Expand/Collapse
 * Cards activate on hover or click with smooth animations
 */

export function initServiceCards() {
    const container = document.getElementById('service-cards-container');
    if (!container) return;
    
    const allCards = Array.from(container.querySelectorAll('.service-card'));
    if (allCards.length === 0) return;
    
    let activeCard = allCards[0];
    const animationDuration = 400; // ms
    
    // Get the description element from a card
    function getDescription(card) {
        return card.querySelector('p');
    }
    
    // Calculate full height of description
    function getFullHeight(element) {
        const originalMaxHeight = element.style.maxHeight;
        const originalOverflow = element.style.overflow;
        element.style.maxHeight = 'none';
        element.style.overflow = 'visible';
        const height = element.scrollHeight;
        element.style.maxHeight = originalMaxHeight;
        element.style.overflow = originalOverflow;
        return height;
    }
    
    // Set transition on description
    function setTransition(desc) {
        desc.style.transition = `max-height ${animationDuration}ms cubic-bezier(0.25, 0.46, 0.45, 0.94)`;
    }
    
    // Collapse a card with smooth animation
    function collapseCard(card) {
        const desc = getDescription(card);
        if (!desc) return;
        
        setTransition(desc);
        
        // Set current height explicitly first
        desc.style.maxHeight = desc.scrollHeight + 'px';
        
        // Force reflow using requestAnimationFrame for smoother animation
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                desc.style.maxHeight = '2.8em';
            });
        });
        
        card.classList.remove('active', 'border-primary');
        card.classList.add('collapsed', 'border-gray-200');
    }
    
    // Expand a card with smooth animation
    function expandCard(card) {
        const desc = getDescription(card);
        if (!desc) return;
        
        setTransition(desc);
        
        const fullHeight = getFullHeight(desc);
        
        // Set collapsed height first
        desc.style.maxHeight = '2.8em';
        
        // Force reflow using requestAnimationFrame for smoother animation
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                desc.style.maxHeight = fullHeight + 'px';
            });
        });
        
        card.classList.remove('collapsed', 'border-gray-200');
        card.classList.add('active', 'border-primary');
        
        // After animation completes, set to none for flexible content
        setTimeout(() => {
            if (card.classList.contains('active')) {
                desc.style.maxHeight = 'none';
            }
        }, animationDuration + 50);
    }
    
    // Function to set active card
    function setActiveCard(card) {
        if (!card || card === activeCard) return;
        
        if (activeCard) {
            collapseCard(activeCard);
        }
        
        expandCard(card);
        activeCard = card;
    }
    
    // Initialize first card as expanded
    const firstDesc = getDescription(allCards[0]);
    if (firstDesc) {
        firstDesc.style.maxHeight = 'none';
    }
    
    // Click and Hover event listeners
    allCards.forEach((card) => {
        // Click to activate
        card.addEventListener('click', function() {
            setActiveCard(this);
        });
        
        // Hover to activate
        card.addEventListener('mouseenter', function() {
            setActiveCard(this);
        });
    });
}
